module.exports = __webpack_public_path__ + "static/img/02036C_1_V_20201118_1_2_LC.187bd0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02036C_1_V_20201118_1_2_LC.png
// module id = p2Bd
// module chunks = 0